import { NotificationSettings } from '@repo/types'

export enum ActionType {
  CHECK_AUTH = 'CHECK_AUTH',
  SET_AUTH = 'SET_AUTH',
  LOGIN_USER = 'LOGIN_USER',
  LOGOUT_USER = 'LOGOUT_USER',

  SET_PROFILE = 'SET_PROFILE',
  GET_PROFILE = 'GET_PROFILE',
  UPDATE_PROFILE = 'UPDATE_PROFILE',

  SET_SHOPIFY_USER = 'SET_SHOPIFY_USER',

  GET_OTP_CODE = 'GET_OTP_CODE',
  SET_OTP_CODE = 'SET_OTP_CODE',

  ACCOUNT_LINK_CHECK = 'ACCOUNT_LINK_CHECK',
  SET_ACCOUNT_LINK = 'SET_ACCOUNT_LINK',
  LINK_ACCOUNTS = 'LINK_ACCOUNTS',
  ACCOUNT_LINK_CONFIRM = 'ACCOUNT_LINK_CONFIRM',

  SET_SCAN_HASH = 'SET_SCAN_HASH',
  LOGIN_SHOPIFY_USER = 'LOGIN_SHOPIFY_USER',

  GOOGLE_LOGIN_REQUEST = 'auth/GOOGLE_LOGIN_REQUEST',
  GOOGLE_LOGIN_SUCCESS = 'auth/GOOGLE_LOGIN_SUCCESS',
  GOOGLE_LOGIN_FAILURE = 'auth/GOOGLE_LOGIN_FAILURE',
}

export type IProfileData = {
  id: string
  first_name: string
  last_name: string
  username: string | null
  birthday: string | null
  avatar: string | null
  phone: string | null
  email: string
  active: boolean
  country: string | null
  gender: Gender | null
  created_at: string
  updated_at: string
  userId: string
  // VRG-139 / VERA-291: marketing consent + per-category notification prefs.
  // Optional because older profile payloads may not carry them.
  email_marketing_consent?: boolean | null
  sms_marketing_consent?: boolean | null
  notification_settings?: NotificationSettings | null
  // VERA-291 slice 3, batch 4 — derived server-side from phone_verified_at
  // (GetCustomerProfileResponseDto). Optional for the same reason as above.
  phone_verified?: boolean
}

type Gender = 'male' | 'female' | 'transgender' | 'non_binary'

export type ILinkAccountsParams = {
  companyId: string
  email: string
}

export type LoginUserPayload = {
  email: string
}

export type LoginUserData = {
  otpReference: string
}

export type VerifyUserPayload = {
  otpCode: string
  otpReference: string
}

export type VerifyUserData = {
  access_token: string
  refresh_token: string
  scan_token: string
}

export type UpdateUserProfilePayload = {
  first_name: string
  last_name: string
  username: string | null
  birthday: Date | null
  phone: string | null
  country: string | null
  gender: string | null
  avatar: File | string | null
  // VRG-139 / VERA-291: optional so partial patches (marketing consent,
  // notification prefs) can be dispatched without the full form payload.
  email_marketing_consent?: boolean
  sms_marketing_consent?: boolean
  notification_settings?: NotificationSettings | null
}

export type UploadCustomerImageResponse = {
  path: string
}

export type LoginShopifyUserPayload = {
  shopify_token: string
}
